import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useConfig } from 'dashboard/composables/useConfig';
import { differenceInDays } from 'date-fns';

export function useUpgradePage() {
  const { currentAccount, isOnChatwootCloud } = useAccount();
  const { isEnterprise } = useConfig();

  const testLimit = ({ allowed, consumed }) => {
    return consumed > allowed;
  };

  const isTrialAccount = computed(() => {
    // check if account is less than 15 days old
    const account = currentAccount.value;
    if (!account) return false;

    const createdAt = new Date(account.created_at);
    const diffDays = differenceInDays(new Date(), createdAt);

    return diffDays <= 15;
  });

  const isLimitExceeded = computed(() => {
    const account = currentAccount.value;
    if (!account?.limits) return false;

    const {
      conversation,
      non_web_inboxes: nonWebInboxes,
      agents,
    } = account.limits;

    return (
      testLimit(conversation) || testLimit(nonWebInboxes) || testLimit(agents)
    );
  });

  const shouldShowUpgradePage = computed(() => {
    if (!isEnterprise) return false;
    if (!isOnChatwootCloud.value) return false;
    if (isTrialAccount.value) return false;
    return isLimitExceeded.value;
  });

  return {
    shouldShowUpgradePage,
    isLimitExceeded,
    isTrialAccount,
    isEnterprise,
    isOnChatwootCloud,
  };
}
